import './WristSelector.less';
import React, {useState, useEffect} from 'react';
import __ from "../../../i18n";
import AspectContainer from '../../../components/aspect-container/AspectContainer';


export default function WristSelector(
    {
        wristPrototypes,
        defaultSelectedWristPrototypeId = null,
        defaultWristPerimeter = null,
        onSelectedWristPrototypeIdChange = (selectedId) => {},
    }
) {

    const [selectedWristPrototypeId, setSelectedWristPrototypeId] = useState(defaultSelectedWristPrototypeId);

    useEffect(() => {
        if (selectedWristPrototypeId !== defaultSelectedWristPrototypeId) {
            onSelectedWristPrototypeIdChange(selectedWristPrototypeId);
        }
    }, [selectedWristPrototypeId]);

    useEffect(() => {
        if (wristPrototypes.some(t => t.id === selectedWristPrototypeId)) {
            return;
        }

        if (wristPrototypes.some(t => t.id === defaultSelectedWristPrototypeId)) {
            setSelectedWristPrototypeId(defaultSelectedWristPrototypeId);
            return;
        }

        const samePerimeterWrist = wristPrototypes.find(t => t.wrist_perimeter === defaultWristPerimeter);
        if (samePerimeterWrist) {
            setSelectedWristPrototypeId(samePerimeterWrist.id);
            return;
        }

        setSelectedWristPrototypeId(wristPrototypes[0].id);
    }, [wristPrototypes]);

    return <div className="wrist-selector">
        <ul>
            {
                wristPrototypes.map(item => {
                    return <li
                        key={item.id}
                        onClick={() => setSelectedWristPrototypeId(item.id)}
                        className={item.id === selectedWristPrototypeId ? 'selected' : ''}
                    >
                        <AspectContainer ratio={1}>
                            {__(':size cm', {
                                size: item.wrist_perimeter / 10
                            })}
                        </AspectContainer>
                    </li>;
                })
            }
        </ul>
    </div>;
}
